// import 'bootstrap';
// import 'mdbootstrap';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import 'mdbootstrap/css/mdb.min.css';
global.jQuery = require('jquery');
global.$ = global.jQuery;

import * as core from '../libs/tech.core'
import * as lazyLoad from '../libs/tech.lazy-load'
import * as ajaxRequest from '../libs/tech.ajax-request'
import * as phone from '../libs/tech.phone'
import * as captchaV3 from '../libs/tech.captchaV3'

$(function () {
    lazyLoad.initLazyLoad('.lazyBackground');

    if ($('#defender-form').length > 0) {
        tech.core.loadFormValidator('#defender-form');
        tech.core.bindCustomCheckbox('#defender-form', function(){
            tech.core.checkDefenderForm('#defender-form','#defender-form .btn-send');
        });
        $('form input, form textarea').keyup(function() {
            tech.core.checkDefenderForm('#defender-form','#defender-form .btn-send');
        });
    }
})

export { core, ajaxRequest, phone, captchaV3 }